import React from 'react'
import { makeStyles, Button, Box } from '@material-ui/core'
import Alert from '@material-ui/lab/Alert'
import PropTypes from 'prop-types'

// NOTE: flexible wrapping functionality is missin out of the box. Hopefully this gets fixed as
// React Alert matures out of 'lab', at which point
const useStyles = makeStyles(({ spacing }) => ({
  message: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    padding: 0
  },
  button: {
    marginLeft: 'auto',
    marginRight: '-8px'
  }
}))

export default function AlertWapper({ message, severity, actionText, actionHandler }) {
  const classes = useStyles()

  return (
    <Alert
      severity={severity}
      classes={{ message: classes.message }}
    >
      <Box py={1}>{message}</Box>
      <Button className={classes.button} size='small' onClick={actionHandler} color='inherit'>
        {actionText}
      </Button>
    </Alert>
  )
}

AlertWapper.propTypes = {
  message: PropTypes.string,
  severity: PropTypes.string,
  actionText: PropTypes.string,
  actionHandler: PropTypes.func
}
